import CadastroInstituicao from "./AreasCadastro/CadastroInstituicao";
import CadastroRepresentante from "./AreasCadastro/CadastroRepresentante";
import CadastroSenha from "./AreasCadastro/CadastroSenha";
import Logo from "../../components/Logo";

import React, { useContext, useState } from "react";

import { Instituicao } from "../../model/Instituicao";
import { Membro } from "../../model/Membro";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import registroInicialCompleto from "../../services/registroInicialCompleto";
import Modal from "react-responsive-modal";
import styles from "./styles.module.css";
import ModalFeedBack from "../../components/ModalFeedback";

function Cadastro() {
  const [abaAtual, setAba] = useState([true, false, false]);
  const passarPagina = (destino: number) => {
    const bolArr = [false, false, false];
    bolArr[destino] = true;
    setAba(bolArr);
  };
  const navigate = useNavigate();
  const {
    setExp,
    setAuthTime,
    setEmail,
    setName,
    setCnpj,
    setInstId,
    setToken,
  } = useContext(UserContext);

  const [novaInstituicao, setInstituicao] = useState<Instituicao>();
  const [novoMembro, setMembro] = useState<Membro>();
  const [novaSenha, setNovaSenha] = useState<string>();
  const [showFeedback, setFeedBack] = useState(false);

  const saveAccount = async (e: React.FormEvent<HTMLFormElement>) => {
    if (!novaInstituicao) {
      return passarPagina(0);
    }
    if (
      !novoMembro ||
      !novoMembro.data_inicio_mandato ||
      !novoMembro.data_fim_mandato
    ) {
      return passarPagina(1);
    }
    if (!novaSenha) {
      return passarPagina(2);
    }
    try {
      registroInicialCompleto(
        {
          nome: novoMembro.nome,
          cpf: novoMembro.cpf,
          email: novoMembro.email,
          senha: novaSenha,
        },
        {
          nome: novaInstituicao.nome,
          cnpj: novaInstituicao.cnpj,
          email: novaInstituicao.email,
          telefone: novaInstituicao.telefone,
          endereco: {
            cep: novaInstituicao.endereco.cep,
            cidade: novaInstituicao.endereco.cidade,
            estado: novaInstituicao.endereco.estado,
            bairro: novaInstituicao.endereco.bairro,
            rua: novaInstituicao.endereco.rua,
            numero: novaInstituicao.endereco.numero,
            complemento: novaInstituicao.endereco.complemento,
          },
        },
        {
          rg: novoMembro.rg,
          orgao: novoMembro.orgao,
          cargo: novoMembro.cargo,
          endereco: {
            cep: novoMembro.endereco.cep,
            cidade: novoMembro.endereco.cidade,
            estado: novoMembro.endereco.estado,
            bairro: novoMembro.endereco.bairro,
            rua: novoMembro.endereco.rua,
            numero: novoMembro.endereco.numero,
            complemento: novoMembro.endereco.complemento,
          },
          data_inicio_mandato:
            typeof novoMembro.data_inicio_mandato === "string"
              ? `${novoMembro.data_inicio_mandato}`
              : novoMembro.data_inicio_mandato?.toISOString().split("T")[0],

          data_fim_mandato:
            typeof novoMembro.data_fim_mandato === "string"
              ? `${novoMembro.data_fim_mandato}`
              : novoMembro.data_fim_mandato?.toISOString().split("T")[0],
        }
      ).then((response) => {
        const { userCredential, instCredential, token } = response;
        const authTime = Date.now();
        const expirationTime = authTime + 60 * 1000;

        setExp(new Date(expirationTime).getTime());
        setAuthTime(new Date(authTime).getTime());
        setName(userCredential.name || "");
        setEmail(userCredential.email || "");
        setCnpj(instCredential.cnpj);
        setInstId(instCredential.id);
        setToken(token);
        navigate("/conta");
      });
      console.log("Registrado");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <section className={styles.cadastroPg}>
      <header>
        <Logo />
      </header>

      <main>
        <form
          className={styles.formCadastro}
          onSubmit={(e) => e.preventDefault()}
        >
          <div hidden={!abaAtual[0]}>
            <CadastroInstituicao
              passarPagina={passarPagina}
              setInstituicao={setInstituicao}
            />
          </div>
        </form>
        <form
          className={styles.formCadastro}
          onSubmit={(e) => e.preventDefault()}
        >
          <div hidden={!abaAtual[1]}>
            <CadastroRepresentante
              passarPagina={passarPagina}
              setMembro={setMembro}
            />
          </div>
        </form>
        <form
          className={styles.formCadastro}
          onSubmit={(e) => {
            e.preventDefault();
            saveAccount(e);
          }}
        >
          <div hidden={!abaAtual[2]}>
            <CadastroSenha
              passarPagina={passarPagina}
              setNovaSenha={setNovaSenha}
            />
          </div>
        </form>
      </main>

      <ModalFeedBack setFeedBack={setFeedBack} showFeedback={showFeedback} />
    </section>
  );
}

export default Cadastro;
